<div #frequencyViewChartContainer
     [style.height.px]="height"
     [style.width.px]="width">
</div>
